import React from "react";
import { useSecurityReportDownloader } from "../../../../data/reports/securityCommission/securityDaily/hooks/useSecurityReportDownloader";
import { useDailySecurityExcelDownloader } from "../../../../data/reports/securityCommission/securityDaily/hooks/useDailySecurityExcelDownloader";
import DownloadIcon from "@material-ui/icons/CloudDownloadOutlined";
import ExcelIcon from "@material-ui/icons/TableChartOutlined";
import { IconButton } from "@material-ui/core";
import { CustomTooltip } from "../../../components/common/CustomTooltip";

export const DownloadButton: React.FunctionComponent = () => {
  const [downloader, fetchState] = useSecurityReportDownloader();
  return (
    <CustomTooltip titleKeyword="exportPDFTooltip">
      <IconButton
        color="secondary"
        component="span"
        onClick={downloader}
        disabled={fetchState.type !== "not-started"}
      >
        <DownloadIcon />
      </IconButton>
    </CustomTooltip>
  );
};

export const DownloadExcelButton: React.FunctionComponent = () => {
  const [downloader, fetchState] = useDailySecurityExcelDownloader();
  return (
    <CustomTooltip titleKeyword="exportXLSXTooltip">
      <IconButton
        color="secondary"
        component="span"
        onClick={downloader}
        disabled={fetchState.type !== "not-started"}
      >
        <ExcelIcon />
      </IconButton>
    </CustomTooltip>
  );
};
